import { Grid, Typography, TextField, Input, Button, Link } from '@mui/material'
import colors from '../../../../../colors'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { sendGeneralRequest } from '../../../../../../features/generalRequest'
import { makeStyles } from '@mui/styles';
import { selectUserInfo } from '../../../../../../features/userInfo/userInfoSlice';
import { selectUtilityState, setSentFrom } from '../../../../../../features/utilities/utilitySlice';
import { selectMyContractsState, setShouldFillFields } from '../../../../../../features/myContracts/myContractsSlice';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';
import { texts } from '../../../../../general/texts';

export const Abissnet = (props) => {

    const userInfo = useSelector(selectUserInfo)
    const utilitySliceState = useSelector(selectUtilityState) 
    const myContractsSliceState = useSelector(selectMyContractsState)
    const navigate = useNavigate()

    const [state, setState] = React.useState({
        utilityName: props.utilityName,
        token: props.globalDataSliceState.token,
        accountNumber: '',
        months: 1
    })
    const dispatch = useDispatch()
    
    const handleInputChange = (e) => {
    //setValue(event.target.value === '' ? '' : Number(event.target.value));
    setState({
        ...state,
        months: Number(e.target.value)
    })
    };

    const handleTextFieldChange = (prop) => (e) => 
    {
        setState({
            ...state,
            [prop]: e.target.value
        })
    }

    const handleButtonClick = (sentFrom) => 
    {
        dispatch(sendGeneralRequest({request: {token: state.token, accountNumber: state.accountNumber, months: state.months}, baseUrlKey:'services', endpoint: 'Abissnet/StartTransactionAbissnet'} ))
        dispatch(setSentFrom(sentFrom))
    }
    
    const handleBlur = () => {
        if (state.months < 1) {
            setState({
                ...state,
                month: 1
            })   
        } else if (state.months > 12) {
            setState({
                ...state,
                month: 12
            })   
        }
    };

    React.useEffect(()=>{
        if(myContractsSliceState.shouldFillFields)
        {
            setState({
                ...state,
                accountNumber: props.selectedContractInfo.contract
            })
            dispatch(setShouldFillFields(false))
        }
    },[myContractsSliceState.shouldFillFields])

    const useStyles = makeStyles({
        mainGrid:{
            padding: '5%',
            paddingTop: '3%'
        },
        utilityName:{
            color:props.utilityInfo.Color,
            fontSize:'1.5rem',
            fontFamily:'GerberaBold',
            paddingTop:'3%',
            paddingLeft:'2%'
        },
        headerBox:{
            backgroundColor:colors.cyan,
            borderRadius:'100%',
            width:'70px',
            height:'70px'
        },
        fieldTitle:{
            color:colors.darkBlue,
            fontSize:'1.2rem',
            fontFamily:'GerberaBold',
            textAlign:'left'
        },
        button:{
            width:'100%',
            color:colors.white,
            fontSize:'1rem',
            textTransform:'none',
            background:colors.gradientOrange,
            fontFamily:'GerberaBold'
        },
        buttonGrid:{
            marginTop: 180,
            paddingBottom: 5
        },
        image:{
            width:'70%',
        },
        textField:{
            width:'100%'
        }
    })

    const classes = useStyles()

  return (
    <Grid container item className={classes.mainGrid} rowSpacing={3}>
        <Grid container item md={2} xs={2} mt={2} ><Link component={'button'} onClick={()=> { navigate(-1)}}><ArrowBackIosNewIcon color='warning' /></Link></Grid>
        <Grid container item md={12} xs={12}>
            <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.headerBox} ><img src={props.utilityInfo.Images.filter(image => image.color === 1 && image.size === 1)[0].imagePath} className={classes.image}/></Grid>
            <Typography className={classes.utilityName} >{props.utilityInfo.PublicName}</Typography>
        </Grid>
        <Grid container item md={12} xs={12} >
            <Typography className={classes.fieldTitle}>{texts["prompt-fill-fields"]}</Typography>
        </Grid>
        <Grid container item md={12} xs={12}  >
            <TextField onChange={handleTextFieldChange('accountNumber')} value={state.accountNumber} color='warning' size='small' label={texts["placeholder-utility-client-number"]} className={classes.textField} />
        </Grid>
        <Grid container item md={6} xs={12} flexDirection={'column'} >
            <Typography className={classes.fieldTitle} >{texts["title-months-count"]}</Typography>
            <Input  value={state.months} onChange={handleInputChange} onBlur={handleBlur} color='warning' inputProps={{ step: 1, min: 0, max: 12, type: 'number', 'aria-labelledby': 'input-slider'}} />
        </Grid>
        <Grid container item rowSpacing={3} >
            <Grid item md={12} xs={12} className={classes.buttonGrid} >
                <Button disabled={utilitySliceState.isLoading ? true : false} onClick={()=>{handleButtonClick('singleInvoice')}} className={classes.button} >{texts["title-pay"]}</Button>
            </Grid>
        </Grid>
    </Grid>
  )
}
export default Abissnet

